module.exports = __webpack_public_path__ + "static/media/no-search-results-v2.f76581a0.svg";